import { parseMultipleEmails } from "utils";

const EMAIL_REGEX = /^\S+@\S+\.\S+$/;

export const validateEmail = (value: string): boolean => {
  const emails = parseMultipleEmails(value);
  return emails.every((email) => EMAIL_REGEX.test(email));
};
